import React from "react";
import ReactDOM from "react-dom/client";
import Root from "./Root";
import "./App.scss";
import { Provider } from "react-redux";
import store from "./store";
import { setStore } from "./storeRef";
import { OidcProvider } from "@axa-fr/react-oidc";
import AuthenticationComplete, {
  AuthenticationExpiry,
} from "pages/Authentication/AuthenticationComplete";
import AuthenticationLoading from "pages/Authentication/AuthenticationLoading";

import {
  configurationIdentityServer,
  loadAppConfig,
} from "./services/configService";

const root = ReactDOM.createRoot(document.getElementById("root"));

function ConfigError({ error }) {
  return (
    <div>
      <h2>Unable to load app configuration</h2>
      <pre>{String(error)}</pre>
    </div>
  );
}

async function bootstrap() {
  try {
    setStore(store);

    await loadAppConfig();

    root.render(
      <OidcProvider
        configuration={configurationIdentityServer()}
        loadingComponent={AuthenticationLoading}
        authenticatingComponent={AuthenticationLoading}
        callbackSuccessComponent={AuthenticationComplete}
        sessionLostComponent={AuthenticationExpiry}
      >
        <Provider store={store}>
          <Root />
        </Provider>
      </OidcProvider>,
    );
  } catch (err) {
    root.render(<ConfigError error={err} />);
  }
}

bootstrap();
